module.exports = "/_next/static/images/818124bd0687da2ce8bcf778537ae920-shield.svg";